import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey"; // Copyright 2017-2021 @polkadot/metadata authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Struct } from '@polkadot/types/codec';
import { assert } from '@polkadot/util';
import { toV10 } from "./v9/toV10.mjs";
import { toV11 } from "./v10/toV11.mjs";
import { toV12 } from "./v11/toV12.mjs";
import { toLatest } from "./v12/toLatest.mjs";
import { MagicNumber } from "./MagicNumber.mjs";
import { getUniqTypes as _getUniqTypes, toCallsOnly } from "./util/index.mjs";

var _converted = _classPrivateFieldLooseKey("converted");
/**
 * @name MetadataVersioned
 * @description
 * The versioned runtime metadata as a decoded structure
 */


export var MetadataVersioned =
/*#__PURE__*/
function (_Struct) {
  _inherits(MetadataVersioned, _Struct);

  function MetadataVersioned(registry, value) {
    var _this;

    _classCallCheck(this, MetadataVersioned);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MetadataVersioned).call(this, registry, {
      magicNumber: MagicNumber,
      metadata: 'MetadataAll'
    }, value));
    Object.defineProperty(_assertThisInitialized(_this), _converted, {
      writable: true,
      value: new Map()
    });
    return _this;
  }

  _createClass(MetadataVersioned, [{
    key: "_assertVersion",
    value: function _assertVersion(version) {
      assert(this.version <= version, "Cannot convert metadata from v".concat(this.version, " to v").concat(version));
      return this.version === version;
    }
  }, {
    key: "_getVersion",
    value: function _getVersion(version, fromPrev) {
      var asCurr = "asV".concat(version);
      var asPrev = "asV".concat(version - 1);

      if (this._assertVersion(version)) {
        return this._metadata[asCurr];
      }

      if (!_classPrivateFieldLooseBase(this, _converted)[_converted].has(version)) {
        _classPrivateFieldLooseBase(this, _converted)[_converted].set(version, fromPrev(this.registry, this[asPrev], this.version));
      }

      return _classPrivateFieldLooseBase(this, _converted)[_converted].get(version);
    }
    /**
     * @description Returns the wrapped metadata as a limited calls-only (latest) version
     */

  }, {
    key: "getUniqTypes",
    value: function getUniqTypes(throwError) {
      return _getUniqTypes(this.registry, this.asLatest, throwError);
    }
  }, {
    key: "asCallsOnly",
    get: function get() {
      return new MetadataVersioned(this.registry, {
        magicNumber: this.magicNumber,
        metadata: this.registry.createType('MetadataAll', toCallsOnly(this.registry, this.asLatest), this.version)
      });
    }
    /**
     * @description Returns the wrapped metadata as a V9 object
     */

  }, {
    key: "asV9",
    get: function get() {
      this._assertVersion(9);

      return this._metadata.asV9;
    }
    /**
     * @description Returns the wrapped values as a V10 object
     */

  }, {
    key: "asV10",
    get: function get() {
      return this._getVersion(10, toV10);
    }
    /**
     * @description Returns the wrapped values as a V11 object
     */

  }, {
    key: "asV11",
    get: function get() {
      return this._getVersion(11, toV11);
    }
    /**
     * @description Returns the wrapped values as a V12 object
     */

  }, {
    key: "asV12",
    get: function get() {
      return this._getVersion(12, toV12);
    }
    /**
     * @description Returns the wrapped values as a latest version object
     */

  }, {
    key: "asLatest",
    get: function get() {
      // This is non-existent & latest - applied here to do the module-specific type conversions
      return this._getVersion(13, toLatest);
    }
    /**
     * @description
     */

  }, {
    key: "magicNumber",
    get: function get() {
      return this.get('magicNumber');
    }
    /**
     * @description the metadata wrapped
     */

  }, {
    key: "_metadata",
    get: function get() {
      return this.get('metadata');
    }
    /**
     * @description the metadata version this structure represents
     */

  }, {
    key: "version",
    get: function get() {
      return this._metadata.index;
    }
  }]);

  return MetadataVersioned;
}(Struct);